import React from "react";
import {OverviewWrapper, SalesWrapper, MenuWrapper, ReviewWrap} from "./Overview.styles";
import {PieChart} from "@mui/x-charts";
import Pakistani_Karahi from "assets/Pakistani-Karahi.png";
import Reviews from "components/atoms/Store/Overview/Reviews/Index";
import ContentHeader from "components/atoms/ContentHeading/ContentHeader";
import RecentReviews from "components/atoms/Store/Overview/RecentReview";
import user_review_img from "assets/user-review-img.png";
const Overview = () => {
    const chartData = [
        {label: "Hardee’s Gulberg", value: 9348319, color: "#313131"},
        {label: "Taste of Lahore-Wembley", value: 8348319, color: "#7DF500"},
        {label: "Taste of Lahore-Hounslow", value: 3348319, color: "#777777"},
    ];
    const menuData = [
        {
            image: Pakistani_Karahi,
            name: "Chicken Karahi",
            price: 70.45,
            id: "67384917",
        },
        {
            image: Pakistani_Karahi,
            name: "Paratha Roll",
            price: 70.45,
            id: "67384917",
        },
        {
            image: Pakistani_Karahi,
            name: "Fresh Naan",
            price: 70.45,
            id: "67384917",
        },
    ];
    const reviewData = [
        {
            img: user_review_img,
            name: "Tina Harris",
            date: "June 4, 2022",
            para: "We recently had dinner with friends at David CC and we all walked away with a great experience. Good food, pleasant environment, personal attention through all the evening. Thanks to the team and we will be back!",
        },
    ];
    return (
        <>
            <OverviewWrapper>
                <SalesWrapper>
                    <strong className="title">Restaurant Wise Sales</strong>
                    <div className="sale-chart">
                        <div className="chart">
                            <PieChart
                                series={[
                                    {
                                        innerRadius: 60,
                                        outerRadius: 80,
                                        data: chartData,
                                        cornerRadius: 12,
                                        colorScheme: chartData.map(item => item.color),
                                    },
                                ]}
                                margin={{right: 5}}
                                width={255}
                                height={255}
                                legend={{hidden: true}}
                            />
                        </div>
                        <div className="sales-info">
                            {chartData.map((item, index) => (
                                <div className="info" key={index} style={{color: item.color}}>
                                    <span>{item.label}</span>
                                    <span className="value" style={{color: item.color}}>
                                        Rs {item.value.toLocaleString()}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </SalesWrapper>
                <MenuWrapper>
                    <strong className="title">Top Food Menu</strong>
                    <div className="menu-header">
                        <span>Item</span>
                        <span>Price</span>
                        <span>Product ID</span>
                    </div>
                    <div className="menu-content">
                        {menuData.map((item, index) => (
                            <div className="menu-item" key={index}>
                                <div className="item-info">
                                    <img src={item.image} alt={item.name} className="item-image" />
                                    <span>{item.name}</span>
                                </div>
                                <span className="item-price">Rs {item.price.toFixed(2)}</span>
                                <span className="item-id">{item.id}</span>
                            </div>
                        ))}
                    </div>
                </MenuWrapper>

                <Reviews />
            </OverviewWrapper>
            <ReviewWrap>
                <ContentHeader title="Recent Reviews" para="Total 101" placeholder="Search in Reviews" noButton />
                <RecentReviews data={reviewData} />
            </ReviewWrap>
        </>
    );
};

export default Overview;
